module.exports = __webpack_public_path__ + "img/trends_20.6cefdee2.jpg";